module.exports = __webpack_public_path__ + "img/big_bg.b4f4afc6.png";